import React from "react"
import CityCards, { AirlineFacilityCard } from "./CityCard"
import Main from "./MaintitleDesc"
import Carosol from "./CarouselWrapper"
export default function popularCities(props) {
  return (
    <>
      <Main {...props} />
      {props.cards.length?
      <Carosol data={props.cards/* .slice(6,20) */} child={props?.isAirlineFacility ? AirlineFacilityCard : CityCards} />:null}
    </>
  )
}
